module.exports = __webpack_public_path__ + "static/about-one-1b84a7679058dc1ba97d666524d47d2d.webp";